import LearningEventsTemplate from "../../templates/LearningEventsTemplate/LearningEventsTemplate";
import useFetch from "../../../hooks/useFetch";
import { learningEventsRepository } from "../../../repository/learningEvents.repository";
import { useContext, useEffect } from "react";
import { PostContext } from "../../../contexts/PostContext";
import { Loader } from "../../atoms/Loader/Loader";
import { useDocumentTitleLoading } from "../../../hooks/useDocumentTitle";
import { FilterContextProvider } from "../../../contexts/FilterContext";

const LearningEvents = () => {
  const { data, fetchData } = useFetch();
  const { isResponseOk } = useContext(PostContext);

  useDocumentTitleLoading();

  useEffect(() => {
    if (isResponseOk || !data) {
      fetchData(learningEventsRepository.getLearningEvents());
    }
  }, [isResponseOk]);

  return data ? (
    <FilterContextProvider>
      <LearningEventsTemplate data={data} />
    </FilterContextProvider>
  ) : (
    <Loader />
  );
};

export default LearningEvents;
